import { createFileRoute } from "@tanstack/react-router";
import { canvasQuery } from "@/lib/api";
import { CanvasScreen } from "./-canvas/CanvasScreen";
import { CanvasPending } from "./-canvas/CanvasSkeleton";
import { graphQuery } from "./-canvas/graphQuery";
import { loadElk } from "./-canvas/layout";

export const Route = createFileRoute("/$workspace/$project/")({
  staticData: { title: "Canvas" },
  // Start the graph, the saved layout and the layout engine while the screen's code downloads.
  loaderDeps: ({ search }) => ({ env: (search as { env?: string }).env ?? "production" }),
  loader: ({ context, params, deps }) => {
    void context.queryClient.prefetchQuery(graphQuery(params.project, deps.env));
    void context.queryClient.prefetchQuery(canvasQuery(params.project));
    void loadElk();
  },
  pendingComponent: CanvasPending,
  pendingMs: 150,
  pendingMinMs: 200,
  component: CanvasScreen,
});
